import { useHistory } from 'react-router';

const useSelectExpDetailsTemplate = () => {
  const history = useHistory();

  return (newTemplateId?: string | null) => {
    const currentSearchParams = new URLSearchParams(history.location.search);
    const newSearchParams = new URLSearchParams();
    const currentExperimentTab = currentSearchParams.get('experiment-tab');
    const currentExperiments = currentSearchParams.get('experiments');

    if (currentExperiments) {
      newSearchParams.set('experiments', currentExperiments);
    }

    if (currentExperimentTab) {
      newSearchParams.set('experiment-tab', currentExperimentTab);
    }

    if (newTemplateId) {
      newSearchParams.set('viewId', newTemplateId);
    }

    history.push({
      search: newSearchParams.toString()
    });
  };
};

export default useSelectExpDetailsTemplate;
